/** Lynx BLE service UUID (must match LynxAdvertiserPlugin.swift). */
export const PROXIMITY_SERVICE_UUID = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890';

/** Prefix for advertisement local name: `Lynx|<userId>`. */
export const LYNX_LOCAL_NAME_PREFIX = 'Lynx|';

export const DEFAULT_LOST_TIMEOUT_MS = 15_000;

/** Retry delay when a native scan session fails (Lynx DEFAULT_CONFIG.scanIntervalMs). */
export const DEFAULT_SCAN_RETRY_MS = 2_000;

/** How often the lost-peer watcher runs (Lynx LynxService.startLostWatcher). */
export const LOST_WATCH_INTERVAL_MS = 1_000;
